// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExchangeLevel2_btnAddFriend__szVLH {
    display: flex; 
    align-items: center; 
    gap: 8px; 
    background-color: #ffc843; 
    border: 2px solid #FFF; 
    border-radius: 5px; 
    padding: 10px 20px; 
    font-size: 16px; 
    font-weight: bold;
    color: #1f1f1f; 
    cursor: pointer; 
    transition: all 0.3s ease;
    width: 100%;
    justify-content: center;
    margin-bottom: 20px;
}

.ExchangeLevel2_iconBtnAddFriend__9iVqP {
    width: 25px;
    height: 25px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
}

.ExchangeLevel2_inputWallet__F6R\\+v {
    border-radius: 5px;
    border-color: #FFF;
    background-color: white;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    padding: 0 15px;
    color: black;
    font-weight: 300;
}
.ExchangeLevel2_label__Tlt5L {
    font-weight: 300;
    margin-bottom: 10px;
}

.ExchangeLevel2_inputPlaceholder__E3Lwb {
    font-weight: 300;
}

.ExchangeLevel2_emptyInputAlert__uWNyQ {
    background-color: salmon;
    font-weight: 300;
    text-align: center;
    border-radius: 5px;
    color: black;
    padding: 5px 0px 5px 0px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Exchange/ExchangeLevel2/ExchangeLevel2.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;AAC5B","sourcesContent":[".btnAddFriend {\n    display: flex; \n    align-items: center; \n    gap: 8px; \n    background-color: #ffc843; \n    border: 2px solid #FFF; \n    border-radius: 5px; \n    padding: 10px 20px; \n    font-size: 16px; \n    font-weight: bold;\n    color: #1f1f1f; \n    cursor: pointer; \n    transition: all 0.3s ease;\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.iconBtnAddFriend {\n    width: 25px;\n    height: 25px;\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 2;\n}\n\n.inputWallet {\n    border-radius: 5px;\n    border-color: #FFF;\n    background-color: white;\n    width: 100%;\n    height: 40px;\n    margin-bottom: 20px;\n    padding: 0 15px;\n    color: black;\n    font-weight: 300;\n}\n.label {\n    font-weight: 300;\n    margin-bottom: 10px;\n}\n\n.inputPlaceholder {\n    font-weight: 300;\n}\n\n.emptyInputAlert {\n    background-color: salmon;\n    font-weight: 300;\n    text-align: center;\n    border-radius: 5px;\n    color: black;\n    padding: 5px 0px 5px 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnAddFriend": `ExchangeLevel2_btnAddFriend__szVLH`,
	"iconBtnAddFriend": `ExchangeLevel2_iconBtnAddFriend__9iVqP`,
	"inputWallet": `ExchangeLevel2_inputWallet__F6R+v`,
	"label": `ExchangeLevel2_label__Tlt5L`,
	"inputPlaceholder": `ExchangeLevel2_inputPlaceholder__E3Lwb`,
	"emptyInputAlert": `ExchangeLevel2_emptyInputAlert__uWNyQ`
};
export default ___CSS_LOADER_EXPORT___;
